import React, { useEffect, useState } from "react";
import { ThumbsUp, Heart, Star, PartyPopper } from "lucide-react";
import "./Blog.css";

const defaultReactions = {
  like: 0,
  love: 0,
  wow: 0,
  celebrate: 0,
};

// Lucide icon components for unselected state
const lucideIconMap = {
  like: ThumbsUp,
  love: Heart,
  wow: Star,
  celebrate: PartyPopper,
};

// Font Awesome class names for selected state
const faIconClassMap = {
  like: "fa-solid fa-thumbs-up",
  love: "fa-solid fa-heart",
  wow: "fa-solid fa-star",
  celebrate: "fa-solid fa-face-laugh-beam", // celebratory FA icon
};

const ReactionBar = ({ blogId }) => {
  const [reactions, setReactions] = useState(defaultReactions);
  const [selected, setSelected] = useState(null);

  useEffect(() => {
    const fetchReactions = async () => {
      try {
        const res = await fetch(`http://localhost:5000/api/reactions/${blogId}`);
        const data = await res.json();
        setReactions((prev) => ({ ...prev, ...data }));
      } catch (err) {
        console.error("❌ Failed to fetch reactions:", err);
      }
    };

    if (blogId) fetchReactions();
  }, [blogId]);

  const handleReaction = async (type) => {
    setReactions((prev) => {
      const updated = { ...prev };
      if (selected && selected !== type) {
        updated[selected] = Math.max(0, updated[selected] - 1);
      }
      updated[type] = (updated[type] || 0) + 1;
      return updated;
    });

    setSelected(type);

    try {
      await fetch("http://localhost:5000/api/reactions", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ blogId, type }),
      });
    } catch (err) {
      console.error("❌ Failed to store reaction:", err);
    }
  };

  return (
    <div className="blog-detail-hbt-reaction-bar">
      {Object.keys(lucideIconMap).map((type) => {
        const LucideIcon = lucideIconMap[type];
        const isSelected = selected === type;

        return (
          <button
            key={type}
            onClick={() => handleReaction(type)}
            className={`blog-detail-hbt-reaction-btn ${isSelected ? "selected" : ""}`}
            aria-label={`React with ${type}`}
          >
            {isSelected ? (
              <i className={`${faIconClassMap[type]}`} style={{ color: "#b8860b", fontSize: "20px" }}></i>
            ) : (
              <LucideIcon size={20} stroke="#666" />
            )}
            <span className="blog-detail-hbt-count">{reactions[type]}</span>
          </button>
        );
      })}
    </div>
  );
};

export default ReactionBar;
